module.exports = __webpack_public_path__ + "img/img21.967be83d.png";